import {
  ListBox as AriaListBox,
  ListBoxItem as AriaListBoxItem,
  ListBoxProps as AriaListBoxProps,
  Collection,
  Header,
  ListBoxItemProps,
  Section,
  composeRenderProps,
} from "react-aria-components";
import { composeTailwindRenderProps } from "../../cn";
import Icon from "../../foundations/Icons/Icon";
import { DropdownSectionProps, itemStyles } from "./types";
import { base } from "../Menu/styles";

type ListBoxProps<T> = Omit<AriaListBoxProps<T>, "layout" | "orientation">;

export function ListBox<T extends object>({
  children,
  ...props
}: ListBoxProps<T>) {
  return (
    <AriaListBox
      {...props}
      className={composeTailwindRenderProps(props.className, "outline-0 ")}
    >
      {children}
    </AriaListBox>
  );
}

export function ListBoxItem(props: ListBoxItemProps) {
  const textValue =
    props.textValue ??
    (typeof props.children === "string" ? props.children : undefined);
  return (
    <AriaListBoxItem {...props} textValue={textValue} className={itemStyles}>
      {composeRenderProps(props.children, (children) => (
        <>{children}</>
      ))}
    </AriaListBoxItem>
  );
}

export function DropdownItem(props: ListBoxItemProps) {
  const textValue =
    props.textValue ??
    (typeof props.children === "string" ? props.children : undefined);
  return (
    <AriaListBoxItem
      {...props}
      textValue={textValue}
      className={base + " h-12 w-full"}
    >
      {composeRenderProps(props.children, (children, { isSelected }) => (
        <>
          <span className="flex items-center flex-1 gap-2 truncate">
            {children}
          </span>
          <span className="flex items-center w-5">
            {isSelected && <Icon icon="check" className="size-4" />}
          </span>
        </>
      ))}
    </AriaListBoxItem>
  );
}

export function DropdownSection<T extends object>(
  props: DropdownSectionProps<T>,
) {
  return (
    <Section>
      <Header>{props.title}</Header>
      <Collection items={props.items}>{props.children}</Collection>
    </Section>
  );
}
